import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import DeleteModal from "../../components/Common/DeleteModal";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { map, isEmpty, size } from "lodash";

import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

import {
  addEmailListTarget,
  getEmailListTarget,
  updateEmailListTarget,
  deleteEmailListTarget,
} from "../../store/actions";

const EmailListTarget = props => {
  const {
    emaillisttargets,
    loading,
    addEmailListTarget,
    onGetEmailListTarget,
    onDeleteProType,
    onUpdateEmailListTarget,
    t,
  } = props;

  const [emailListTarget, setEmailListTarget] = useState({});
  const [isRight, setIsRight] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    onGetEmailListTarget(localStorage.getItem("userId"));
  }, [onGetEmailListTarget]);

  useEffect(() => {
    if (!isEmpty(emaillisttargets)) {
      setIsEdit(false);
    }
  }, [emaillisttargets]);

  const toggleCanvas = () => setIsRight(prev => !prev);

  const openEditCanvas = item => {
    setEmailListTarget({
      id: item.id,
      emailListTargetId: item.emailListTargetId,
      emailListTargetTitle: item.emailListTargetTitle,
      agentId: item.agentId,
      isActive: item.isActive,
    });
    setIsEdit(true);
    toggleCanvas();
  };

  const handleAdd = values => {
    addEmailListTarget(values);
  };

  const onClickDelete = item => {
    setEmailListTarget(item);
    setDeleteModal(true);
  };

  const handleDelete = () => {
    if (emailListTarget?.id) {
      onDeleteProType(emailListTarget);
      setDeleteModal(false);
    }
  };

  return (
    <React.Fragment>
      {loading && <div className="loading">Loading…</div>}

      <ToastContainer autoClose={2000} />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
       

        <Container fluid>
          <Row className="mb20">
            <Col xl="12">
              <Breadcrumbs title={t("General Settings")} breadcrumbItem={t("Email List Target")} />
            </Col>
          </Row>

          <Row>
           

            <Col xl="12">
              {/* ===== ADD FORM ===== */}
              <Formik
                enableReinitialize
                initialValues={{
                  emailListTargetTitle: "",
                  agentId: parseInt(localStorage.getItem("userId")),
                }}
                validationSchema={Yup.object({
                  emailListTargetTitle: Yup.string().required("This is required"),
                })}
                onSubmit={handleAdd}
              >
                {({ errors, touched, handleChange }) => (
                  <Form>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col sm="3">
                            <FormGroup>
                              <Label>{t("Title")}</Label>
                              <SafeField
                                name="emailListTargetTitle"
                                onChange={handleChange}
                                className={`form-control ${
                                  errors.emailListTargetTitle && touched.emailListTargetTitle
                                    ? "is-invalid"
                                    : ""
                                }`}
                              />
                              <ErrorMessage
                                name="emailListTargetTitle"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>

                          <Col sm="2" className="">
                            <Button type="submit" color="primary" className="mt-4">
                              Add
                            </Button>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Form>
                )}
              </Formik>

              {/* ===== LIST ===== */}
              <Card>
                <CardBody>
                  <h5>History</h5>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Title</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {map(emaillisttargets, (item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{item.emailListTargetTitle}</td>
                            <td>
                              <ActionEdit onClick={() => openEditCanvas(item)} />
                              <ActionDelete onClick={() => onClickDelete(item)} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* ===== UPDATE OFFCANVAS ===== */}
          <Offcanvas isOpen={isRight} direction="end" toggle={toggleCanvas}>
            <OffcanvasHeader toggle={toggleCanvas}>Update</OffcanvasHeader>
            <OffcanvasBody>
              <Formik
                enableReinitialize
                initialValues={emailListTarget}
                validationSchema={Yup.object({
                  emailListTargetTitle: Yup.string().required("This is required"),
                })}
                onSubmit={values => {
                  if (isEdit) {
                    const updateData = {
                      id: values.id,
                      emailListTargetId: values.emailListTargetId,
                      emailListTargetTitle: values.emailListTargetTitle,
                      agentId: values.agentId,
                    };
                    onUpdateEmailListTarget(updateData);
                  }
                  toggleCanvas();
                }}
              >
                {({ errors, touched, handleChange }) => (
                  <Form>
                    <FormGroup>
                      <Label>{t("Title")}</Label>
                      <SafeField
                        name="emailListTargetTitle"
                        onChange={handleChange}
                        className={`form-control ${
                          errors.emailListTargetTitle && touched.emailListTargetTitle
                            ? "is-invalid"
                            : ""
                        }`}
                      />
                      <ErrorMessage
                        name="emailListTargetTitle"
                        component="div"
                        className="invalid-feedback"
                      />
                    </FormGroup>

                    <Button type="submit" color="primary">
                      Update
                    </Button>
                  </Form>
                )}
              </Formik>
            </OffcanvasBody>
          </Offcanvas>
        </Container>
      </div>
    </React.Fragment>
  );
};

EmailListTarget.propTypes = {
  t: PropTypes.any,
  loading: PropTypes.bool,
  emaillisttargets: PropTypes.array,
  addEmailListTarget: PropTypes.func,
  onGetEmailListTarget: PropTypes.func,
  onDeleteProType: PropTypes.func,
  onUpdateEmailListTarget: PropTypes.func,
};

const mapStateToProps = ({ ObjectReducer }) => ({
  emaillisttargets: ObjectReducer.emaillisttargets,
  loading: ObjectReducer.loading,
});

const mapDispatchToProps = dispatch => ({
  addEmailListTarget: data => dispatch(addEmailListTarget(data)),
  onGetEmailListTarget: agentId => dispatch(getEmailListTarget(agentId)),
  onDeleteProType: data => dispatch(deleteEmailListTarget(data)),
  onUpdateEmailListTarget: data => dispatch(updateEmailListTarget(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EmailListTarget));
